import { render, staticRenderFns } from "./CvoDetailActivityDelivery.vue?vue&type=template&id=dfe85a8c&"
import script from "./CvoDetailActivityDelivery.vue?vue&type=script&lang=js&"
export * from "./CvoDetailActivityDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports